import { markerSrcMain, markerSrcLogo, categoryMarkers } from './markers';
import axios from 'axios';
import 'snazzy-info-window/dist/snazzy-info-window.scss';

function LocationMap(options, mapElement, apiEndPoints, hrefRoute){
	this.mapElement = mapElement;
	this.apiEndPoints = apiEndPoints;
	this.hrefRoute = hrefRoute;

	//default options
	this.options = {
		'zoomLvl' : 15,
		'mapType' : 'roadmap'
	};

	//voeg input opties samen met default opties
	for (var attrname in options) { this.options[attrname] = options[attrname]; }

	this.menuElements = new Array();
	this.catSlugs = new Array();

	switch(this.options.locationType){
		case 'voorzieningen':
			//setup classes
			this.mapElement.classList.add('loading');

			this.updateNavigation = this.updateNavigation.bind(this);

			this.parseVoorzieningen = this.parseVoorzieningen.bind(this);
			this.parseVoorzieningenRequest = new XMLHttpRequest();
			this.parseVoorzieningenRequest.addEventListener('readystatechange', this.parseVoorzieningen);

			this.parseVoorzieningenRequest.open('POST', this.apiEndPoints.services);
			this.parseVoorzieningenRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

			this.parseVoorzieningenRequest.send();
			break;
		case 'projecten':
			axios.get(this.apiEndPoints.projecten + '&gebied_id=' + this.options.gebiedId)
				.then((gebiedenData) => {
					this.setupGebiedenMap(gebiedenData);
				})
				.catch(function (error) {
					console.log(error);
				})
				.finally(function () {
					
				});
			break;
		case 'coordinaten':
			this.location = {lat: this.options.location[0], lng: this.options.location[1]}
			this.setupMap();
			break;
		case 'adres':
		default:
			if(google){
				var _this = this;
				this.geocoder = new google.maps.Geocoder();
				if(Array.isArray(this.options.location)){
					for(var i=0;i<this.options.location.length;i++){
						this.geocoder.geocode( { 'address': this.options.location[i]}, function(results, status){ _this.parseGeo(results, status);});
					}
				}
				else {
					this.geocoder.geocode( { 'address': this.options.location}, function(results, status){ _this.parseGeo(results, status);});
				}
			}
			else {
				console.warn('De Google Maps api is niet ingeladen.')
			}
			break;
	}
}

LocationMap.prototype.parseVoorzieningen = function(){
	if(this.parseVoorzieningenRequest.readyState != 4) return;
	if(this.parseVoorzieningenRequest.status != 200 && this.parseVoorzieningenRequest.status != 304) {
		console.log('HTTP error ' + this.parseVoorzieningenRequest.status);
		return;
	}

	if(!this.parseVoorzieningenRequest.responseText){
		this.onError('Kan voorzieningen data niet ophalen');
	}

	this.mapElement.classList.remove('loading');

	this.voorzieningenData = JSON.parse(this.parseVoorzieningenRequest.responseText);

	this.setupVoorzieningenMap();
}

LocationMap.prototype.parseGeo = function(results, status){
	if(status == 'OK'){
		if(Array.isArray(this.options.location)){
			if(!this.location){
				this.location = new Array();
			}
			this.location.push(results[0].geometry.location);
			if(this.location.length == this.options.location.length){
				this.setupMap();
			}
		}
		else {
			this.location = results[0].geometry.location;
		  	this.setupMap();
		}
	}
	else {
		this.mapElement.parentNode.removeChild(this.mapElement);
	}
}

LocationMap.prototype.setupMap = function(){
	this.googleMap = this.createAndReturnMap();

	var image = {
		url: this.options.themeUrl + '/' + markerSrcLogo,
		scaledSize: new google.maps.Size(250, 120),
		anchor: new google.maps.Point(125, 120)
	};

	var _this = this;

	if(Array.isArray(this.location)){
		var bounds = new google.maps.LatLngBounds();

		for(var i=0;i<this.location.length;i++){
			bounds.extend(this.location[i]);

			var marker = new google.maps.Marker({
				position: this.location[i],
				map: this.googleMap,
				icon: image
			});
		}
		this.googleMap.fitBounds(bounds);
	}
	else {

		var marker = new google.maps.Marker({
	    	position: this.location,
			map: this.googleMap,
			icon: image
		});
		google.maps.event.addListener(marker, 'click', function() {
			window.open(
			  _this.hrefRoute + '?daddr=' + _this.options.location,
			  '_blank'
			);
		});
	}

	if(this.options.buildLocation) {
		let mapItems = this.createSiteOverlay(
			this.options.buildLocation.constructionLocation,
			this.options.buildLocation.cLocationNorth,
			this.options.buildLocation.cLocationSouth,
			this.options.buildLocation.cLocationWest,
			this.options.buildLocation.cLocationEast
		);

		if(mapItems){
			for(let i=0;i<mapItems.length;i++){
				if(mapItems[i]){
					mapItems[i].setMap(this.googleMap);
				}
			}
		}
	}

	if(this.options.centreLocation){
		let mapItems = this.createSiteOverlay(
			this.options.centreLocation.imageSrc,
			this.options.centreLocation.coordNorth,
			this.options.centreLocation.coordSouth,
			this.options.centreLocation.coordWest,
			this.options.centreLocation.coordEast,
			{
				url: this.options.themeUrl + '/' + this.getMarkerSrc('centrum', categoryMarkers),
				scaledSize : new google.maps.Size(40, 40),
				anchor: new google.maps.Point(20, 20)
			}
		);

		if(mapItems){
			for(let i=0;i<mapItems.length;i++){
				if(mapItems[i]){
					mapItems[i].setMap(this.googleMap);
				}
			}
		}
	}
}

LocationMap.prototype.setupVoorzieningenMap = function() {
	this.googleMap = this.createAndReturnMap( new google.maps.LatLng(this.voorzieningenData[0].coordinates.latitude, this.voorzieningenData[0].coordinates.longitude) );

	var navigationElement = this.createNavigation();
	if(navigationElement.nodeType == 1){
		this.mapElement.appendChild(navigationElement);
	}

	var latLngBounds = new google.maps.LatLngBounds();
	var _this = this;
	for(var i=0;i<this.voorzieningenData.length;i++){
		var image = {
			url: this.options.themeUrl + '/' + this.getMarkerSrc(this.voorzieningenData[i].categories[0].slug, categoryMarkers),
			scaledSize : new google.maps.Size(40, 40),
			anchor: new google.maps.Point(20, 20)
		};

		this.voorzieningenData[i].marker = new google.maps.Marker({
			position: new google.maps.LatLng(this.voorzieningenData[i].coordinates.latitude, this.voorzieningenData[i].coordinates.longitude),
			map: this.googleMap,
			icon: image
		});

		this.voorzieningenData[i].markerActive = true;

		this.voorzieningenData[i]['infowindow'] = new google.maps.InfoWindow({
			content: this.voorzieningenData[i].name
		});

		google.maps.event.addListener(this.voorzieningenData[i].marker, 'click', function(e) {
			_this.displayInfoWindow(this);
		});
	}

	this.updateNavigation();

	for(var i=0;i<this.voorzieningenData.length;i++){
		if(this.voorzieningenData[i].markerActive){
			latLngBounds.extend(new google.maps.LatLng(this.voorzieningenData[i].coordinates.latitude, this.voorzieningenData[i].coordinates.longitude));
		}
	}

	if(this.options.buildLocation) {
		let mapItems = this.createSiteOverlay(
			this.options.buildLocation.constructionLocation,
			this.options.buildLocation.cLocationNorth,
			this.options.buildLocation.cLocationSouth,
			this.options.buildLocation.cLocationWest,
			this.options.buildLocation.cLocationEast
		);

		if(mapItems){
			for(let i=0;i<mapItems.length;i++){
				mapItems[i].setMap(this.googleMap);
				if(mapItems[i] && mapItems[i].position){
					latLngBounds.extend(mapItems[i].position);
				}
			}
		}
	}

	if(this.options.centreLocation){
		let mapItems = this.createSiteOverlay(
			this.options.centreLocation.imageSrc,
			this.options.centreLocation.coordNorth,
			this.options.centreLocation.coordSouth,
			this.options.centreLocation.coordWest,
			this.options.centreLocation.coordEast,
			{
				url: this.options.themeUrl + '/' + this.getMarkerSrc('centrum', categoryMarkers),
				scaledSize : new google.maps.Size(40, 40),
				anchor: new google.maps.Point(20, 20)
			}
		);


		if(mapItems){
			for(let i=0;i<mapItems.length;i++){
				if(mapItems[i]){
					mapItems[i].setMap(this.googleMap);
					if(mapItems[i] && mapItems[i].position){
						latLngBounds.extend(mapItems[i].position);
					}
				}
			}
		}
	}

	this.googleMap.fitBounds(latLngBounds);
}

LocationMap.prototype.setupGebiedenMap = function(gebiedenData) {
	const SnazzyInfoWindow = require('snazzy-info-window');

	var mapOptions = {
		zoom: this.options.zoomLvl,
		disableDefaultUI: false,
		scrollwheel: false,
		disableDoubleClickZoom: false,
		mapTypeControl: false,
		fullscreenControl: false,
		streetViewControl: false,
		draggable: true,
		panControl: false,
		zoomControl: false,
		center: {lat: gebiedenData.data[0].coordinates.lat, lng: gebiedenData.data[0].coordinates.lng},
		mapTypeId: 'hybrid',
	};

	var mapContainerElement = document.querySelector('.mmap-wrapper');

	this.googleMap = new google.maps.Map(mapContainerElement, mapOptions);

	var bounds = new google.maps.LatLngBounds();
	var _this = this;

	for(var i=0; i<gebiedenData.data.length; i++){

		if(gebiedenData.data.length > 1){
			var marker = new google.maps.Marker({
				map: this.googleMap,
				draggable: false,
				position: new google.maps.LatLng(gebiedenData.data[i].coordinates.lat, gebiedenData.data[i].coordinates.lng),
			});
	
			gebiedenData.data[i].infowindow = new SnazzyInfoWindow({
				marker: marker,
				content: '<a href="' + gebiedenData.data[i].link + '"<div class="infowindow-gebieden"><img class="infowindow-image" src="' + gebiedenData.data[i].thumbnail +'" ><div class="infowindow-title">' + gebiedenData.data[i].title + '</div></div>',
				position: new google.maps.LatLng(gebiedenData.data[i].coordinates.lat, gebiedenData.data[i].coordinates.lng),
				map: this.googleMap,
				offset: {
					top: '0px'
				},
				closeOnMapClick: false,
				showCloseButton: true,
				panOnOpen: false,
			});
		}else{
			gebiedenData.data[i].infowindow = new SnazzyInfoWindow({
				marker: marker,
				content: '<a href="' + gebiedenData.data[i].link + '"<div class="infowindow-gebieden"><img class="infowindow-image" src="' + gebiedenData.data[i].thumbnail +'" ><div class="infowindow-title">' + gebiedenData.data[i].title + '</div></div>',
				position: new google.maps.LatLng(gebiedenData.data[i].coordinates.lat, gebiedenData.data[i].coordinates.lng),
				map: this.googleMap,
				offset: {
					top: '0px',
				},
				closeOnMapClick: false,
				showCloseButton: false,
				panOnOpen: false,
			});
		}

		bounds.extend(gebiedenData.data[i].coordinates);

		gebiedenData.data[i].infowindow.open();
	}

	bounds = this.addBoundsPadding(bounds);

	this.googleMap.fitBounds(bounds);

	window.gebiedenData = gebiedenData;
}

LocationMap.prototype.addBoundsPadding = function(bounds){
	var cne = bounds.getNorthEast();
	var czw = bounds.getSouthWest();

	var ne = {
		lat: cne.lat() + 0.0070,
		lng: cne.lng() + 0.0070
	};

	var zw = {
		lat: czw.lat() - 0.0070,
		lng: czw.lng() - 0.0070
	};

	bounds.extend(ne);
	bounds.extend(zw);

	return bounds;
}

LocationMap.prototype.createAndReturnMap = function( defaultLocation ) {
	if (!defaultLocation) {
		defaultLocation = this.location;
 	 }

	if(this.options.mapType == 'roadmap'){
		var styles = [
			{
				"featureType": "poi",
				"elementType": "labels",
				"stylers": [
					{ "visibility": "off" }
				]
			},{
			"stylers": [
				{ "lightness": 30 },
				{ "saturation": -30 },
				{ "gamma": 0.8 }
			]
			},{
			"featureType": "landscape"  }
		];

		var styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"});
	}

	var mapOptions = {
		zoom: this.options.zoomLvl,
		disableDefaultUI: false,
		scrollwheel: false,
		mapTypeControl: false,
		panControl: true,
		streetViewControl: false,
    	center: defaultLocation,
   		mapTypeId: this.options.mapType,
	};

	if( this.options.locationType != 'voorzieningen') {
		mapOptions.draggable = false;
		mapOptions.panControl = false;
		mapOptions.fullscreenControl = false;
	}

	const googleMap = new google.maps.Map(this.mapElement, mapOptions);

	if (this.options.mapType == 'roadmap') {
		googleMap.mapTypes.set('map_style', styledMap);
		googleMap.setMapTypeId('map_style');
	}

	return googleMap;
};

LocationMap.prototype.createSiteOverlay = function(overlaySrc, north, south, west, east, markerImage) {
	if(!overlaySrc && typeof overlaySrc != 'string'){
		return false;
	}

	if(!markerImage){
		var markerImage = {
			url: this.options.themeUrl + '/' + markerSrcMain,
			scaledSize: new google.maps.Size(40, 55.5),
			anchor: new google.maps.Point(20, 55.5)
		};
	}

	var marker = false;

	if(this.options.locationType == 'voorzieningen'){
		var markerLat = Math.abs((north + south) / 2);
		var markerLong = Math.abs((east + west) / 2);

		marker = new google.maps.Marker({
			position: new google.maps.LatLng(markerLat, markerLong),
			icon: markerImage
		});
	}

	var imageBounds = {
		north: north,
		south: south,
		east: east,
		west: west
	};

	var overlay = new google.maps.GroundOverlay(
		overlaySrc,
		imageBounds
	);

	return [overlay, marker];
}

LocationMap.prototype.createNavigation = function(){
	var navigationElement = document.createElement('nav');
	navigationElement.setAttribute('class', 'kaart-navigation-wrapper');

	var navigationMenuElement = document.createElement('ul');
	navigationMenuElement.setAttribute('class', 'kaart-navigation');

	const cats = this.getUsedCategories(this.voorzieningenData);

	for(let i=0;i<cats.length;i++){
		let navigationMenuItemElement = document.createElement('li');
		navigationMenuItemElement.setAttribute('class', 'kaart-navigation-menu-item voorziening-cat-' + cats[i].slug);
		if(this.options.activeCategories){
			for(let j=0;j<this.options.activeCategories.length;j++){
				if(cats[i].term_id = this.options.activeCategories[j].value){
					navigationMenuItemElement.classList.add('is-active');
					break;
				}
			}
		}
		else if(i == 0){
			navigationMenuItemElement.classList.add('is-active');
		}
		navigationMenuItemElement.setAttribute('data-category', cats[i].slug);

		let navigationMenuButtonElement = document.createElement('button');
		navigationMenuItemElement.appendChild(navigationMenuButtonElement);

		navigationMenuButtonElement.addEventListener('click', this.updateNavigation);

		let labelElement = document.createElement('span');
		labelElement.setAttribute('class', 'kaart-navigation-menu-item-label')
		labelElement.appendChild(document.createTextNode(cats[i].name));

		navigationMenuItemElement.appendChild(labelElement);

		this.menuElements.push(navigationMenuItemElement);

		navigationMenuElement.appendChild(navigationMenuItemElement);
	}

	navigationElement.appendChild(navigationMenuElement);

	return navigationElement;
}

LocationMap.prototype.updateNavigation = function(e){
	if(e && e.target){
		var target = e.target;
		while(target && target.nodeName != 'LI'){
			target = target.parentNode;
		}

		target.classList.toggle('is-active');
	}

	for(var i=0;i<this.voorzieningenData.length;i++){
		this.voorzieningenData[i].marker.setMap(null);
		this.voorzieningenData[i].markerActive = false;
	}

	for(var i=0;i<this.voorzieningenData.length;i++){
		for(var j=0;j<this.menuElements.length;j++){
			var found = false;
			for(var k=0;k<this.voorzieningenData[i].categories.length;k++){
				if(this.voorzieningenData[i].categories[k].slug == this.menuElements[j].getAttribute('data-category') && this.menuElements[j].classList.contains('is-active')){
					found = true;
				}
			}
			if(found){
				this.voorzieningenData[i].marker.setMap(this.googleMap);
				this.voorzieningenData[i].markerActive = true;
			}
		}
	}
}

LocationMap.prototype.displayInfoWindow = function(e){
	if(e && e.target){
		var target = e.target;
	}
	else if(e && e.srcElement){
		var target = e.srcElement;
	}
	else {//aanmame is marker
		var marker = e;
	}

	if(target){
		if(target.nodeType != 1 && (target.nodeName != 'LI' || target.nodeName != 'SELECT')){
			return false;
		}

		if(target.nodeName == 'SELECT'){
			var locationId = target.value;
		}
		else {
			while(!target.getAttribute('data-location-id')){
				target = target.parentNode;

			}
			var locationId = target.getAttribute('data-location-id');
		}

		for(var i=0;i<this.voorzieningenData.length;i++){
			this.voorzieningenData[i].infowindow.close();
			if(locationId == this.voorzieningenData[i].id){
				this.map.setZoom(15);
				this.map.panTo(this.voorzieningenData[i].marker.position);
				this.voorzieningenData[i].infowindow.open(this.map, this.voorzieningenData[i].marker);
			}
		}
	}
	else if(marker){
		for(var i=0;i<this.voorzieningenData.length;i++){
			this.voorzieningenData[i].infowindow.close();
			if(marker == this.voorzieningenData[i].marker){
				this.voorzieningenData[i].infowindow.open(this.map, this.voorzieningenData[i].marker);
			}
		}
	}
};

LocationMap.prototype.getMarkerSrc = function(slug, markers) {

	const markersSource = markers.filter(markerSrc => {
		return markerSrc.match(new RegExp('marker-' + slug + '\.[0-9a-f]+\.png'));
	});

	return markersSource.length < 1 ? '' : markersSource[0];
};

LocationMap.prototype.getUsedCategories = function(servicesData) {
	let categories = [];

	servicesData.map((serviceData => {
		categories = categories.concat(serviceData.categories);
	}));

	categories = categories.filter((category, index, self) => {
		return self.indexOf(category) === index;
	})

	return categories;
};

export default LocationMap;